import React, { useState, useCallback } from 'react';

// Components
import WpBanner from '../WpBanner';
import WpIcon from '../../icon/WpIcon';

const BannerDocs = () => {
  const [isShowing, setIsShowing] = useState(true);
  const types = ['blue', 'orange', 'pink', 'purple', 'orange-purple'] as const;

  const onDismissClick = useCallback(() => {
    setIsShowing(false);
  }, []);

  return (
    <>
      {types.map(type => (
        <div className="mb-2">
          <WpBanner key={type} type={type}>
            {type}
          </WpBanner>
        </div>
      ))}
      <h5 className="mt-5">With icon</h5>
      <WpBanner type="blue" icon={<WpIcon name="crown" />}>
        Custom Icon
      </WpBanner>
      <h5 className="mt-5">Dissmissable</h5>
      {isShowing && (
        <WpBanner type="blue" onDismiss={onDismissClick}>
          Dismiss me
        </WpBanner>
      )}
    </>
  );
};

export default BannerDocs;
